module.exports = __webpack_public_path__ + "static/media/Inspiron.b56000cb.png";